import { Alert } from '@mui/material';
import { CircularProgress } from '@mui/material';

/**
 * 
 * @param {object} props {spinner, iconSize, iconColor, children}
 * @returns 
 */
export default function AlertLoading(props) {
    const children  = props.children  || 'Loading...';
    const iconColor = props.iconColor || 'secondary';
    const iconSize  = props.iconSize  || '1.0em';
    const spinner   = (props.spinner === true || props.spinner === undefined);
    const sx        = props.sx
    const inline    = props.inline    || false
    
    return (
        inline
        ?
            <CircularProgress sx={sx} color={iconColor} size={iconSize} />
        :
            <Alert
                sx={sx}
                severity="info"
                icon={
                    spinner
                    ?
                    <CircularProgress color={iconColor} size={iconSize} />
                    :
                    null
                }>
                    {children}
            </Alert>
    )
}